import axios from "axios";
import GetServerAddress from "../../functions/GetServerAddress";

export function Student_Update_To_MongoDB_By_ID_And_Email_Confirmation(
  updateDoc,
  dbName,
  collctiontext,
  setStatus,
  id,
  contacts,
  SuccessText,
  logoutStudent
) {
  setStatus(true);
  const postData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() +
          "api/student/Student_Update_To_MongoDB_By_ID_And_Email_Confirmation",
        {
          updateDoc: updateDoc,
          dbName: dbName,
          collctiontext: collctiontext,
          id: id,
          contacts: contacts,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("StudentToken")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Student_id"),
            activitylog: "Yes",
            aboutid: id,
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logoutStudent();

        return; // Stop further execution in case of invalid auth token
      }
      // Alert for successful POST request
      if (response.data.message === "Success") {
        window.alert(SuccessText);
      }
      setStatus(false);
    } catch (error) {
      console.error("Error Posting data: ", error);
      // Alert for failed POST request
      window.alert(
        "Error Posting data, please speak to InvestIN via info@investin.org if this issue persists: ",
        error
      );
      setStatus(false);
    }
  };
  postData();
} // Empty dependency array means this effect runs only once
